import styles from './styles.module.scss';

import { NavLink as NavigateLink } from 'react-router-dom';

import cn from 'classnames';

const NavLink = ({ to = '', children, className,  ...props }) => (
  <NavigateLink to={to} className={cn(styles.nav_link, className, props.styles)}   {...props}>
    {children}
  </NavigateLink>
);

export default NavLink;
